import type { Pointer } from "./Pointer"

export type Allocated = { readonly pointer: Pointer; readonly free: () => void }
